import script from "./confirm-delete.vue?vue&type=script&setup=true&lang=js"
export * from "./confirm-delete.vue?vue&type=script&setup=true&lang=js"

import "./confirm-delete.vue?vue&type=style&index=0&id=ab33ee6a&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab33ee6a"]])

export default __exports__